<template>
    <div class="case_home">
        <div class="case1">
            <div class="case1_cont">
                <div class="case1_imgbox">
                    <p class="p1">{{ caseData.case.name | nameTongxue }}</p>
                    <p class="p2">同学</p>
                </div>
                <div class="case1_btn" @click="scrollOffer">
                    <p>查看OFFER</p>
                    <img src="../img/vip院校计划/Group 703.png" alt="">
                </div>
                <div class="case1_itembox">
                    <div class="case1_item">
                        <div class="case1_itemmain">
                            <div class="p1">录取院校</div>
                            <div class="p2">{{ schoolArr }}</div>
                        </div>
                    </div>
                    <div class="case1_item">
                        <div class="case1_itemmain">
                            <div class="p1">录取专业</div>
                            <div class="p2">{{ caseData.major.cname }}</div>
                        </div>
                    </div>
                    <div class="case1_item">
                        <div class="case1_itemmain">
                            <div class="p1">申请学历</div>
                            <div class="p2">{{ caseData.case.application_qualification }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="case2">
            <div class="section_box">
                <div class="section_title_cn">作品集展示（部分）</div>
                <div class="section_title_en">PORTFOLIO DISPLAY</div>
            </div>
            <div class="case2_cont">
                <div class="swiper mySwiperCase1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in zuopinji">
                            <img :src="'https://public.rossoarts.com/static/uploads/case/' + item.img" alt="">
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>

            </div>
        </div>

        <div class="case4">
            <div class="scroll_position"></div>
            <div class="section_box">
                <div class="section_title_cn">OFFER展示</div>
                <div class="section_title_en">OFFER DISPLAY</div>
            </div>
           
            <div class="case4_cont">
                <div class="swiper mySwiperCase2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in offerArr">
                            <img :src="'https://public.rossoarts.com/static/uploads/case/' + item.img" alt="">
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import "@/assets/css/caseDetail.css"
import Swiper from 'swiper/bundle'
import 'swiper/css';
import "swiper/css/effect-flip";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
export default {
    data() {
        return {
            caseData: [],
            schools: [],
            schoolArr: [],
            zuopinji: [],
            offerArr: []
        }
    },
    filters: {
        nameTongxue(val) {
            console.log(val);
            if (val.split("同学")) {
                return val.split("同学")[0]
            } else {
                return val
            }

        }
    },
    created() {
        this.getCaseDetail(this.$route.params.id.split(".")[0])
    },
    methods: {
        scrollOffer(){
            var scroll_position = document.getElementsByClassName("scroll_position")
            scroll_position[0].scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        getCaseDetail(val) {
            axios.get(`https://public.rossoarts.com/api/v1/getCase?id=${val}`).then((data) => {
                console.log(data.data.data);

                this.caseData = data.data.data
                this.schools = data.data.data.schools
                this.zuopinji = data.data.data.portfolios
                this.offerArr = data.data.data.offers
                for (var i = 0; i < this.schools.length; i++) {
                    this.schoolArr += this.schools[i].cname + "、"
                }
                this.$nextTick(() => {
                    this.swiperCase1()
                    this.swiperCase2()
                })
            })
        },
        swiperCase1() {
            var swiper = new Swiper('.mySwiperCase1', {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
              
            });

        },
        swiperCase2() {
            var swiper = new Swiper('.mySwiperCase2', {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
              
            });

        },
    }
}
</script>